import React from "react";
import Language from "../../lib/Language";
import { TComponent } from "../../types/utils";

type TTopLeftProps = {
    topLeft?: React.JSX.Element;
    contents: React.JSX.Element | null;
};

const TopLeft: TComponent<TTopLeftProps> = ({ topLeft, contents }) => (
    <div className="listTopLine">
        {topLeft}{" "}
        <span style={{ fontWeight: "bold", paddingLeft: "10px" }} className="summaryLabel">
            {Language.get("nc_exam")}
        </span>
        {contents}
    </div>
);

export default TopLeft;
